import React from 'react'
import { StaticQuery, graphql } from "gatsby"
import Img from 'gatsby-image'
import './Illustration.scss'

export default ({source}) => {
	return(
		<StaticQuery
			query={graphql`
				query illustrationImages {
					processing: file(relativePath: {eq: "img/processing/liqduidation.png"}) {
						childImageSharp {
							fluid(quality: 100, maxWidth: 2000) {
								...GatsbyImageSharpFluid
							}
						}
					}
					storage: file(relativePath: {eq: "img/storage-bunkering/bunkering.png"}) {
						childImageSharp {
							fluid(quality: 100, maxWidth: 2000) {
								...GatsbyImageSharpFluid
							}
						}
					}
				}
			`}
			render={data => (
				<div className="Illustration">
					{
						source === 'processing' &&
						<Img fluid={data.processing.childImageSharp.fluid} />
					}
					{
						source === 'storage' &&
						<Img fluid={data.storage.childImageSharp.fluid} />
					}
				</div>
			)}
		/>
	)
}